module.exports = __webpack_public_path__ + "media/npc_dota_hero_monkey_king.4291e662.webm";